import Vue from "vue"; // 引入 Vue 是因为要用到 Vue.extend() 这个方法
import toast from "./toast.vue"; // 引入刚才的 toast 组件

let ToastConstructor = Vue.extend(toast); // 这个在前面的前置知识内容里面有讲到
let instance;

const Toast = function (options, type) {
  let data = {}
  if (typeof options === 'string') {
    data.content = options
  } else {
    data = options
  }
  data.type = type
  instance = new ToastConstructor({
    data,
  }); 
  document.body.appendChild(instance.$mount().$el); // 渲染组件 挂载到 body 下
};

["success", "error"].forEach(type => {
  Toast[type] = options => {
    // options.type = type;
    return Toast(options,type);
  };
});


export default Toast;


// WEBPACK FOOTER //
// ./src/components/toast/index.js